/*
Report + year-version specific constants
*/

export const REPORT_YEAR = 2018
export const REPORT_CODE = 'sqs'

// Namespaces for vuex store modules
export const NS_REPORT_GROUP = `${REPORT_CODE}`
export const NS_CURRENT_REPORT = `${REPORT_CODE}/${REPORT_YEAR}`



// WEBPACK FOOTER //
// ./src/components/sqs/2018/const.js